import axios, { AxiosRequestConfig } from 'axios'

export const axiosBaseConfig: AxiosRequestConfig = {
  timeout: 10000,
  headers: { 'Content-Type': 'multipart/form-data' }
}
export const axiosInstance = axios.create(axiosBaseConfig)
